
import { ViewEmployee } from '@xeetr/types/models'
import { Copy, Ellipsis, Trash2 } from 'lucide-react'
import { Controller, useFormContext } from 'react-hook-form'

import EmployeeInfo from './EmployeeInfo'
import EmployeeWorkingHours from './EmployeeWorkingHours'

import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Separator } from '@/components/ui/separator'
import { Switch } from '@/components/ui/switch'


interface Props {
  onCopy: () => void
  onDelete: () => void
}

const EmployeeContent = ({ onCopy, onDelete }: Props) => {
  const { control } = useFormContext<ViewEmployee>()

  return (
    <div className="relative flex flex-col gap-5">
      {/* Options Menu */}
      <div className="absolute right-0 top-0">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline" size="icon">
              <Ellipsis className="h-5 w-5" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-56" align="end" side="bottom" sideOffset={5}>
            <div className="space-y-2">
              <p className="text-sm font-semibold">Optionen</p>
              <div className="flex items-center justify-between">
                <span className="text-sm">E-Mail Benachrichtigung</span>
                <Controller
                  name="settings.notify"
                  control={control}
                  render={({ field }) => (
                    <Switch checked={field.value} onCheckedChange={field.onChange} />
                  )}
                />
              </div>
              <Separator />
              <Button variant="ghost" className="w-full justify-start" onClick={() => onCopy()}>
                <Copy className="mr-2 h-4 w-4" />
                Duplizieren
              </Button>
              <Button
                variant="ghost"
                className="w-full justify-start text-red-600 hover:bg-red-50 hover:text-red-700"
                onClick={() => onDelete()}
              >
                <Trash2 className="mr-2 h-4 w-4" />
                Löschen
              </Button>
            </div>
          </PopoverContent>
        </Popover>
      </div>

      {/* Content Sections */}
      <EmployeeInfo />
      <EmployeeWorkingHours />
    </div>
  )
}

export default EmployeeContent
